export interface AdminPrivileges {
  // Admin User Management
  adminUserCreate: boolean;
  adminUserEdit: boolean;
  adminUserList: boolean;
  adminUserView: boolean;
  adminUserActivateDeactivate: boolean;

  // Subscription Management
  subscriptionCreate: boolean;
  subscriptionEdit: boolean;
  subscriptionList: boolean;
  subscriptionView: boolean;
  subscriptionActivateDeactivate: boolean;

  // Offer Management
  offerCreate: boolean;
  offerEdit: boolean;
  offerList: boolean;
  offerView: boolean;
  offerActivateDeactivate: boolean;

  // Client Management
  clientCreate: boolean;
  clientUpdate: boolean;
  clientList: boolean;
  clientView: boolean;
  clientActivateDeactivate: boolean;

  // QMS Document Category Management
  qmsDocCategoryCreate: boolean;
  qmsDocCategoryEdit: boolean;
  qmsDocCategoryList: boolean;
  qmsDocCategoryView: boolean;
  qmsDocCategoryActivateDeactivate: boolean;

  // QMS Document Template Management
  qmsDocTemplateCreate: boolean;
  qmsDocTemplateEdit: boolean;
  qmsDocTemplateList: boolean;
  qmsDocTemplateView: boolean;
  qmsDocTemplateActivateDeactivate: boolean;

  // QMS Document Update Requests
  qmsUpdateRequestList: boolean;
  qmsUpdateRequestView: boolean;
  qmsUpdateRequestEdit: boolean;
  qmsUpdateRequestUpdateStatus: boolean;

  // Service Type Management
  serviceTypeCreate: boolean;
  serviceTypeEdit: boolean;
  serviceTypeList: boolean;
  serviceTypeView: boolean;
  serviceTypeActivateDeactivate: boolean;

  // Technician Management
  technicianCreate: boolean;
  technicianEdit: boolean;
  technicianList: boolean;
  technicianView: boolean;
  technicianActivateDeactivate: boolean;

  // Invoice Template Management
  invoiceTemplateCreate: boolean;
  invoiceTemplateEdit: boolean;
  invoiceTemplateList: boolean;
  invoiceTemplateView: boolean;
  invoiceTemplateActivateDeactivate: boolean;

  // Certificate Template Management
  certificateTemplateCreate: boolean;
  certificateTemplateEdit: boolean;
  certificateTemplateList: boolean;
  certificateTemplateView: boolean;

  // Form Template Management
  formTemplateCreate: boolean;
  formTemplateEdit: boolean;
  formTemplateView: boolean;
  formTemplateList: boolean;

  // Facility Management
  facilityCreate: boolean;
  facilityEdit: boolean;
  facilityList: boolean;
  facilityView: boolean;
  facilityActivateDeactivate: boolean;

  // Equipment Management
  equipmentCreate: boolean;
  equipmentEdit: boolean;
  equipmentList: boolean;
  equipmentView: boolean;

  // Facility User Management
  facilityUserList: boolean;
  facilityUserView: boolean;

  // Service Request Management
  serviceRequestList: boolean;
  serviceRequestView: boolean;
  serviceRequestAssign: boolean;
  serviceRequestUpdateStatus: boolean;
  serviceRequestReschedule: boolean;
  serviceRequestAcceptReject: boolean;

  // Contact Request Management
  contactRequestList: boolean;
  contactRequestView: boolean;
  contactRequestAssign: boolean;
  contactRequestReschedule: boolean;
  contactRequestUpdateStatus: boolean;
  contactRequestAcceptReject: boolean;

  // Certificate Management
  certificateList: boolean;
  certificateView: boolean;
  certificateDownload: boolean;

  // Invoice Management
  invoiceDraftList: boolean;
  invoiceDraftView: boolean;
  invoiceDraftEdit: boolean;
  invoicePublish: boolean;
  invoiceList: boolean;
  invoiceView: boolean;
  invoiceDownload: boolean;

  // Other
  dashboardView: boolean;
  exportReports: boolean;
}

export const initialAdminPrivileges: AdminPrivileges = {
  adminUserCreate: false,
  adminUserEdit: false,
  adminUserList: false,
  adminUserView: false,
  adminUserActivateDeactivate: false,
  subscriptionCreate: false,
  subscriptionEdit: false,
  subscriptionList: false,
  subscriptionView: false,
  subscriptionActivateDeactivate: false,
  offerCreate: false,
  offerEdit: false,
  offerList: false,
  offerView: false,
  offerActivateDeactivate: false,
  clientCreate: false,
  clientUpdate: false,
  clientList: false,
  clientView: false,
  clientActivateDeactivate: false,
  qmsDocCategoryCreate: false,
  qmsDocCategoryEdit: false,
  qmsDocCategoryList: false,
  qmsDocCategoryView: false,
  qmsDocCategoryActivateDeactivate: false,
  qmsDocTemplateCreate: false,
  qmsDocTemplateEdit: false,
  qmsDocTemplateList: false,
  qmsDocTemplateView: false,
  qmsDocTemplateActivateDeactivate: false,
  qmsUpdateRequestList: false,
  qmsUpdateRequestView: false,
  qmsUpdateRequestEdit: false,
  qmsUpdateRequestUpdateStatus: false,
  serviceTypeCreate: false,
  serviceTypeEdit: false,
  serviceTypeList: false,
  serviceTypeView: false,
  serviceTypeActivateDeactivate: false,
  technicianCreate: false,
  technicianEdit: false,
  technicianList: false,
  technicianView: false,
  technicianActivateDeactivate: false,
  invoiceTemplateCreate: false,
  invoiceTemplateEdit: false,
  invoiceTemplateList: false,
  invoiceTemplateView: false,
  invoiceTemplateActivateDeactivate: false,
  certificateTemplateCreate: false,
  certificateTemplateEdit: false,
  certificateTemplateList: false,
  certificateTemplateView: false,
  formTemplateCreate: false,
  formTemplateEdit: false,
  formTemplateView: false,
  formTemplateList: false,
  facilityCreate: false,
  facilityEdit: false,
  facilityList: false,
  facilityView: false,
  facilityActivateDeactivate: false,
  equipmentCreate: false,
  equipmentEdit: false,
  equipmentList: false,
  equipmentView: false,
  facilityUserList: false,
  facilityUserView: false,
  serviceRequestList: false,
  serviceRequestView: false,
  serviceRequestAssign: false,
  serviceRequestUpdateStatus: false,
  serviceRequestReschedule: false,
  serviceRequestAcceptReject: false,
  contactRequestList: false,
  contactRequestView: false,
  contactRequestAssign: false,
  contactRequestReschedule: false,
  contactRequestUpdateStatus: false,
  contactRequestAcceptReject: false,
  certificateList: false,
  certificateView: false,
  certificateDownload: false,
  invoiceDraftList: false,
  invoiceDraftView: false,
  invoiceDraftEdit: false,
  invoicePublish: false,
  invoiceList: false,
  invoiceView: false,
  invoiceDownload: false,
  dashboardView: false,
  exportReports: false,
};
